import { request, withQuery } from './client';
import type { ReceiptData } from '@kassa/shared';

export const receiptsApi = {
  receipt: (id: string, copy: boolean) =>
    request<ReceiptData>('GET', withQuery(`/api/receipts/${encodeURIComponent(id)}`, { copy: copy ? '1' : undefined })),
};
